import ConnectionStatusBadge from "./ConnectionStatusBadge";
import GpsStatusBadge from "./GpsStatusBadge";

interface FieldHeaderProps {
  projetoNome: string;
  connectionStatus: "online" | "offline" | "sincronizando" | "erro";
  gpsStatus: "capturado" | "indisponivel" | "buscando" | "baixa_precisao";
  precisaoGps?: number;
  pendentes: number;
}

export default function FieldHeader({ projetoNome, connectionStatus, gpsStatus, precisaoGps, pendentes }: FieldHeaderProps) {
  return (
    <header className="bg-white border-b border-[#E8EAED] sticky top-0 z-50">
      <div className="px-4 py-2.5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5 min-w-0">
            <div className="w-8 h-8 rounded-lg bg-[#1B6E4F] flex items-center justify-center flex-shrink-0">
              <span className="text-white text-xs font-heading font-bold">FI</span>
            </div>
            <div className="min-w-0">
              <p className="text-xs font-heading font-bold text-[#3F4A52] truncate leading-tight">{projetoNome}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <ConnectionStatusBadge status={connectionStatus} />
            <GpsStatusBadge status={gpsStatus} precisao={precisaoGps} />
            <div className="relative">
              <button className="w-8 h-8 rounded-lg hover:bg-[#E8EAED] flex items-center justify-center transition-colors" aria-label="Sincronização">
                <i className="ri-refresh-line text-[#3F4A52] text-lg" />
              </button>
              {pendentes > 0 && (
                <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-[#D32F2F] text-white text-[10px] font-bold flex items-center justify-center">
                  {pendentes > 9 ? "9+" : pendentes}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}